import React from 'react';
export function HowItWorks() {
  const steps = [{
    number: 1,
    title: 'Gentle warm sensation signals comfort',
    description: 'The warming action begins within minutes of application to provide a soothing signal to your body.'
  }, {
    number: 2,
    title: 'Delivery Duo helps key actives cross the top skin layer',
    description: "Our proprietary blend of borneol and Azone helps transport active ingredients deeper where they're needed most."
  }, {
    number: 3,
    title: 'Proven actives soothe nerve activity around the knee',
    description: 'Menthol and capsaicin work together to calm overactive nerve signals and provide lasting comfort.'
  }];
  const timeline = [{
    time: '0–10 min',
    effect: 'warmth begins'
  }, {
    time: '20–30 min',
    effect: 'peak comfort'
  }, {
    time: 'Up to 6–8 hrs',
    effect: 'sustained relief'
  }];
  return <section className="py-12 bg-white" data-id="element-164">
      <div className="container mx-auto px-4" data-id="element-165">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-8 text-[#0E6B6B]" data-id="element-166">
          Why MyoQuell Feels Different
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-167">
          {steps.map(step => <div key={step.number} className="relative" data-id="element-168">
              <div className="bg-[#EAF7F3] rounded-lg p-6 h-full" data-id="element-169">
                <div className="flex items-center mb-4" data-id="element-170">
                  <div className="w-8 h-8 bg-[#0E6B6B] text-white rounded-full flex items-center justify-center font-bold mr-3" data-id="element-171">
                    {step.number}
                  </div>
                  <h3 className="font-medium" data-id="element-172">{step.title}</h3>
                </div>
                <p className="text-gray-700" data-id="element-173">{step.description}</p>
              </div>
              {step.number < steps.length && <div className="hidden md:block absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 z-10" data-id="element-174">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-175">
                    <path d="M9 5L16 12L9 19" stroke="#0E6B6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-176" />
                  </svg>
                </div>}
            </div>)}
        </div>
        <h3 className="text-xl font-serif font-bold text-center mb-6" data-id="element-177">
          What to Expect
        </h3>
        <div className="flex flex-col md:flex-row justify-between mb-6" data-id="element-178">
          {timeline.map((item, index) => <div key={index} className="bg-[#EAF7F3] rounded-lg p-4 text-center mb-4 md:mb-0 md:w-[30%]" data-id="element-179">
              <div className="font-bold text-[#0E6B6B]" data-id="element-180">{item.time}</div>
              <div data-id="element-181">{item.effect}</div>
            </div>)}
        </div>
        <p className="text-sm text-center text-gray-600" data-id="element-182">
          Sensitivity varies. If it feels too warm, remove and wash the area.
        </p>
      </div>
    </section>;
}